module.exports = __webpack_public_path__ + "img/website-glider.fae318b7.svg";